__turbopack_context__.v({
  "content": "Navigation-module__1FSK1W__content",
  "menu": "Navigation-module__1FSK1W__menu",
  "menuButton": "Navigation-module__1FSK1W__menuButton",
  "menuButtonLabel": "Navigation-module__1FSK1W__menuButtonLabel",
  "menuButtonTitle": "Navigation-module__1FSK1W__menuButtonTitle",
  "menuItem": "Navigation-module__1FSK1W__menuItem",
  "sidebar": "Navigation-module__1FSK1W__sidebar",
  "sidebarToggle": "Navigation-module__1FSK1W__sidebarToggle",
});
